import React, {FC} from 'react';
import {Helmet} from 'react-helmet';
import {useTranslation} from 'react-i18next';
import { SummaryData } from '../../../components/tree+two/summaruData'; 
// import {Apps} from '~/features/apps';
// import {AppHeader} from '~/widgets/ui';
// import {withTariff} from '~/shared/lib/hoc/with-tariff';
// import compose from 'compose-function';
// Приложения страница
const SummaryDataPage: FC = () => {
    const {t} = useTranslation();

    return (
        <>
            <Helmet>
                    <title>Свод данных</title>
                </Helmet>
            <SummaryData/>
            {/* <AppHeader title={t('apps')} /> */}
            {/* <Apps /> */}
        </>
    );
};

    export default SummaryDataPage
